
define('ldsh!modules/form_editor/templates/field_editor_title', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h4><strong>' +
((__t = ( elementName )) == null ? '' : __t) +
': </strong><span data-i18n="formEditor.configTitle">Configuración</span></h4>\n';

}
return __p
};});

